import { Trans } from "@lingui/macro";
import { Typography } from "@mui/material";

export const Loading = () => {
    return (
        <Typography textAlign={'center'}>
            <Trans>Carregando...</Trans>
        </Typography>
    );
}